
    <wms-dialog-header (onClose)="handleLogsViewDialogClose()" [title]="'Logs'"></wms-dialog-header>
    <wms-dialog-body>
        <div class="wm-console-container">
            <div class="debug-log-console">
                <div class="buttons-container">
                    <button type="button" class="btn-transparent refresh" (click)="refreshLogs()" [attr.title]="locale.LABEL_REFRESH_CONSOLE">
                        <i class="wm-icon wms wms-refresh"></i>
                    </button>
                    <button type="button" class="btn-transparent download-server-logs" (click)="downloadLogs()" [attr.title]="locale.LABEL_DOWNLOAD_SERVER_LOGS">
                        <i class="wm-icon wms wms-download"></i>
                    </button>
                </div>
                <tabset class="wm-tabs" #logs_tab_set>
                    <tab heading="{{locale.LABEL_APPLICATION}}" name="wm-app-logs" (selectTab)="switchToApplicationTab();">
                        <div class="logs-container">
                            <p class="console-logs-list logs-list" #application_logs>
                                {{applicationLogs}}
                            </p>
                        </div>
                    </tab>
                    <tab heading="{{locale.LABEL_SERVER}}" name="wm-server-logs" (selectTab)="switchToServerTab();">
                        <div class="logs-container">
                            <p class="console-logs-list logs-list" #server_logs>
                                {{serverLogs}}
                            </p>
                        </div>
                    </tab>
                  <tab  heading="{{locale.LABEL_REACT_NATIVE_BUILD}}"  *ngIf="isNativeMobileApplicationType" name="wm-RnBuild-logs" (selectTab)="switchRNBuildTab();">
                    <div class="logs-container">
                    <p class="console-logs-list logs-list"  tabindex="0" #rnBuild_logs >
                      {{rnBuildLogs}}
                    </p>
                    </div>
                  </tab>
                </tabset>
            </div>
        </div>
    </wms-dialog-body>

